import { Grid, styled } from '@mui/material';

export const FormWrapper = styled(Grid)(({ theme }) => ({
    maxWidth: '500px',
    width: '100%',
    flexDirection: 'column',
    margin: 'auto',
}));

export const FormContent = styled(Grid)(({ theme }) => ({
    gap: '16px',
    margin: '8px auto 40px auto',
}));

export const CountrySelectorWrapper = styled('div')<{ showZip: boolean }>(
    ({ theme, showZip }) => ({
        textAlign: 'left',
        display: 'grid',
        gridTemplateAreas: `
        "${showZip ? 'city zip' : 'city city'}"
    `,
        gridTemplateColumns: '1fr 1fr',
        gap: 16,
        maxWidth: 500,
        width: '100%',
        margin: '0',
        [theme.breakpoints.down('sm')]: {
            gridTemplateAreas: `
           "city"
           ${showZip ? '"zip"' : ''}
        `,
            gridTemplateColumns: '1fr',
        },
    }),
);
